import {DomainObject, oneOf} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import AttachedDocument from 'shared/stores/documents/AttachedDocument';

class TimeTrackingReportDownload extends DomainObject {
  status;
  reportFile;

  _relations = {
    status: oneOf(['pending', 'successful', 'failed']),
    reportFile: AttachedDocument
  };

  constructor(other) {
    super();

    makeObservable(this, {
      status: observable,
      reportFile: observable,
      isFinished: computed
    });

    this.merge(other);
  }

  get isFinished() {
    return this.status === 'successful' || this.status === 'failed';
  }
}

export default TimeTrackingReportDownload;
